import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Hospital } from 'src/app/Models/hospital.model';
import { NarcoticMedicalPolicyAgreement } from 'src/app/Models/narcoticmedicalpolicyagreement.model';
import { NarcoticMedicalPolicyService } from 'src/app/services/narcotic-medical-policy.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-view-narcotic-medical-policy-agreement',
  templateUrl: './view-narcotic-medical-policy-agreement.component.html',
  styleUrls: ['./view-narcotic-medical-policy-agreement.component.css'],
})
export class ViewNarcoticMedicalPolicyAgreementComponent implements OnInit {
  id = 0;
  narcoticList: NarcoticMedicalPolicyAgreement[] = [];
  hospital: Hospital;
  constructor(
    private route: ActivatedRoute,
    private patientService: PatientService,
    private NarcoticMedicalPolicyAgreementService: NarcoticMedicalPolicyService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });
    this.patientService.getpatienHospitalId(this.id).subscribe((res) => {
      this.hospital = res.Hospital;
    });

    this.getHippaCompliance(this.id);
  }

  getHippaCompliance(id) {
    this.patientService
      .GetNarcoticMedicalPolicyAgreement(id)
      .subscribe((res) => {
        this.narcoticList = res.NarcoticMedicalPolicyAgreements;
      });
  }

  print() {
    window.print();
  }

  delete(id) {
    this.NarcoticMedicalPolicyAgreementService.deleteNarcoticMedicalPolicyAgreement(
      id
    ).subscribe((res) => {
      this.getHippaCompliance(this.id);
    });
  }
}
